import '../../LoadPickSubscribers.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper/IAsyncWrapper";
import { createSelector } from "@reduxjs/toolkit";
import { toSingleAsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper/IAsyncWrapper.utils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { MSFT_TENANT_ID, TORUS_TENANT_ID, TenantNamesById } from "@ane/core/lib/services/MSALAuthService/MSAL.constants";
import { SUBSCRIPTION_TYPES } from "@ane/exp-data/lib/models/SubscriberModels";
import { useQuerySubscribersQuery, useQueryAdminSubscribersQuery, rtkQueryHookToAsyncWrapper, useUpdateSubscribersMutation, useLazySearchSubscribersQuery } from "@ane/exp-data/lib/redux/rtkquery";
import ErrorBoundary from "@ane/ui-components/lib/components/ErrorBoundary/ErrorBoundary";
import { PeoplePickerItemSuggestion, ValidationState } from "@ane/ui-components/lib/components/Pickers";
import { SpinnerSize } from "@ane/ui-components/lib/components/Spinner";
import { SubscriberPicker } from "@ane/ui-components/lib/components/SubscriberPicker";
import { getTheme } from "@ane/ui-components/lib/Styling";
/* empty css                                  */import { ARIA_LABELS } from "./LoadPickSubscribers.types.js";
import { TIPS, ADMIN_SUBSCRIBER_SUFFIX, ERROR_TYPES, EmailDomainList } from "./Subscriber.constants.js";
import { convertSubscribersV2, convertSubscribersToUnified } from "./Subscriber.utils.js";
const theme = getTheme();
const focusColor = theme.palette.blue;
const errorColor = theme.palette.redDark;
const defaultColor = theme.palette.neutralSecondary;
const pickerResultLimitDefault = 5;
const pickerResolveDelayDefault = 1500;
const labelProps = {
  text: TIPS.LABEL_TEXT,
  htmlFor: ""
};
const iconProps = {
  ariaLabel: ARIA_LABELS.ICON_HINT,
  iconName: "Info",
  calloutProps: {
    content: TIPS.ICON_CALLOUT_TEXT
  }
};
const spinnerProps = {
  ariaLabel: ARIA_LABELS.SUBSCRIBER_LOADING,
  label: TIPS.LOADING_TEXT,
  size: SpinnerSize.medium,
  labelPosition: "right"
};
const suggestionProps = {
  loadingText: TIPS.SUGGESTION_LOADING_TEXT,
  noResultsFoundText: TIPS.SUGGESTION_NO_RESULT_TEXT,
  suggestionsAvailableAlertText: TIPS.SUGGESTION_AVAILABLE_ALERT_TEXT,
  suggestionsContainerAriaLabel: ARIA_LABELS.SUGGESTED_RESULTS
};
const pickerCalloutProps = {};
const personaStyles = {
  root: {
    width: "auto"
  },
  primaryText: {
    width: "auto"
  },
  secondaryText: {
    width: "auto"
  }
};
const inExperimentationGroup = (eg, experimentationGroups) => {
  if (!eg) {
    return false;
  }
  if (!experimentationGroups || experimentationGroups.length === 0) {
    return true;
  }
  const egLower = eg.toLocaleLowerCase();
  return experimentationGroups.findIndex((g) => g.toLocaleLowerCase() === egLower || (egLower == null ? void 0 : egLower.startsWith(g.toLocaleLowerCase()))) >= 0;
};
const selectAdminSubscribersForEg = createSelector(
  (res) => res.data,
  (res, experimentationGroup) => experimentationGroup,
  (res, experimentationGroup, notificationCategory) => notificationCategory,
  (data, experimentationGroup, notificationCategory) => {
    var _a;
    if (!data) {
      return data;
    }
    if (!experimentationGroup || !notificationCategory) {
      return __spreadProps(__spreadValues({}, data), {
        value: []
      });
    }
    const egLower = experimentationGroup.toLocaleLowerCase();
    return __spreadProps(__spreadValues({}, data), {
      value: (_a = data.value) == null ? void 0 : _a.filter(
        (s) => s.subscriptionType === SUBSCRIPTION_TYPES.Admin && inExperimentationGroup(egLower, s.experimentationGroups)
      )
    });
  }
);
const selectSubscribers = createSelector(
  (res) => res.data,
  (data) => {
    var _a;
    if (!data) {
      return data;
    }
    return __spreadProps(__spreadValues({}, data), {
      value: (_a = data.value) == null ? void 0 : _a.filter((s) => __spreadProps(__spreadValues({}, s), {
        subscriptionType: SUBSCRIPTION_TYPES.EntityBase
      }))
    });
  }
);
const useMergedSubscribers = (props) => {
  const {
    workspaceId,
    experimentationGroupId,
    entityType = "",
    entityExternalId = "",
    notificationCategory,
    fetchPhoto = true
  } = props;
  const subscribersQuery = useQuerySubscribersQuery(
    {
      workspaceId,
      entityType,
      entityExternalId,
      notificationCategory,
      fetchPhoto
    },
    {
      selectFromResult: (res) => __spreadProps(__spreadValues({}, res), {
        data: selectSubscribers(res)
      })
    }
  );
  const adminSubscribersQuery = useQueryAdminSubscribersQuery(
    { workspaceId, notificationCategory: notificationCategory != null ? notificationCategory : "", skip: 0, top: 1e3 },
    {
      skip: !notificationCategory,
      selectFromResult: (res) => __spreadProps(__spreadValues({}, res), {
        data: selectAdminSubscribersForEg(res, experimentationGroupId, notificationCategory)
      })
    }
  );
  const { data: subscribers, isLoading: subscribersLoading } = subscribersQuery;
  const { data: adminSubscribers, isLoading: adminSubscribersLoading } = adminSubscribersQuery;
  const personas = React.useMemo(() => {
    var _a, _b, _c;
    if (subscribersLoading || notificationCategory && adminSubscribersLoading) {
      return [];
    }
    const merged = [
      ...((_a = adminSubscribers == null ? void 0 : adminSubscribers.value) != null ? _a : []).flatMap((s) => s.subscribers).map((s) => {
        var _a2;
        return __spreadProps(__spreadValues({}, s), {
          displayName: ((_a2 = s.displayName) == null ? void 0 : _a2.endsWith(ADMIN_SUBSCRIBER_SUFFIX)) ? s.displayName : s.displayName + ADMIN_SUBSCRIBER_SUFFIX,
          subscriptionType: SUBSCRIPTION_TYPES.Admin
        });
      }),
      ...(_c = (_b = subscribers == null ? void 0 : subscribers.value) == null ? void 0 : _b.flatMap((s) => s.subscribers)) != null ? _c : []
    ].filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
    return convertSubscribersV2(merged);
  }, [subscribers, adminSubscribers, subscribersLoading, adminSubscribersLoading]);
  return {
    personas,
    subscribersQuery,
    adminSubscribersQuery,
    mergedAsyncRequestStatus: toSingleAsyncRequestStatus([
      rtkQueryHookToAsyncWrapper(subscribersQuery).status,
      rtkQueryHookToAsyncWrapper(adminSubscribersQuery).status
    ])
  };
};
const LoadPickSubscribersV2 = (props) => {
  var _a;
  const {
    subscribers: subscribersProps = [],
    workspaceId,
    tenantId = (_a = EnvironmentService.getUser().tid) != null ? _a : "",
    pickerResultLimit: resultLimit = pickerResultLimitDefault,
    pickerResolveDelay: resolveDelay = pickerResolveDelayDefault,
    fetchPhoto = true,
    setSubscribersQueryCacheKey
  } = props;
  const pickerRef = React.useRef(null);
  const { personas, mergedAsyncRequestStatus } = useMergedSubscribers(props);
  const [updateSubscribers, { isLoading: isSetSubscribersLoading }] = useUpdateSubscribersMutation({
    fixedCacheKey: setSubscribersQueryCacheKey
  });
  const [isFocus, setIsFocus] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(props.errorMessage || "");
  const [selectedKeys, setSelectedKeys] = React.useState(() => {
    const options = props.tenantId ? getDropdownOptions(props.tenantId) : [];
    return options.map((o) => o.key);
  });
  const [currentSelected, setCurrentSelected] = React.useState(
    personas.length > 0 ? personas : subscribersProps
  );
  const [triggerSearch] = useLazySearchSubscribersQuery();
  const onFilterChanged = (filterText, currentPersonas, limitResults) => __async(void 0, null, function* () {
    if (filterText) {
      pickerCalloutProps.hidden = false;
      suggestionProps.suggestionsHeaderText = "";
      const result = yield triggerSearch({
        workspaceId,
        searchString: filterText,
        count: resultLimit,
        fetchPhoto,
        domains: props.tenantId === MSFT_TENANT_ID ? "" : selectedKeys.join(",")
      }).unwrap();
      return removeDuplicates(convertSubscribersV2(convertSubscribersToUnified(result)), currentPersonas || []);
    } else {
      return [];
    }
  });
  const removeDuplicates = (personas2, possibleDupes) => {
    const result = personas2.filter((persona) => !listContainsPersona(persona, possibleDupes));
    if (result.length >= resultLimit) {
      suggestionProps.suggestionsHeaderText = `Top ${resultLimit} suggested results`;
      suggestionProps.className = "ms-PeoplePicker-suggestion";
    } else {
      suggestionProps.suggestionsHeaderText = "";
    }
    setErrorMessage("");
    return result;
  };
  const listContainsPersona = (persona, personas2) => {
    if (!personas2 || !personas2.length || personas2.length === 0) {
      return false;
    }
    return personas2.filter((item) => item.text === persona.text).length > 0;
  };
  const onRenderSuggestionItem = (personaProps, suggestionsProps) => {
    const secondaryTextFormted = !!personaProps.tertiaryText ? personaProps.secondaryText + " | " + personaProps.tertiaryText : personaProps.secondaryText;
    return /* @__PURE__ */ jsx(
      PeoplePickerItemSuggestion,
      {
        personaProps: __spreadProps(__spreadValues({}, personaProps), {
          styles: personaStyles,
          secondaryText: secondaryTextFormted
        }),
        suggestionsProps
      }
    );
  };
  const onItemsChange = (items) => {
    setCurrentSelected(items);
    setErrorMessage(props.required && (items == null ? void 0 : items.length) === 0 ? ERROR_TYPES.REQUIRED : "");
    if (!!props.onChange) {
      props.onChange(items);
    }
  };
  const onInputChange = (input) => {
    const outlookRegEx = /<.*>/g;
    const emailAddress = outlookRegEx.exec(input);
    if (emailAddress && emailAddress[0]) {
      return emailAddress[0].substring(1, emailAddress[0].length - 1);
    }
    return input;
  };
  const validateInput = (input) => {
    if (input.indexOf("@") !== -1 && EmailDomainList.includes("@" + input.split("@")[1])) {
      setErrorMessage("");
      return ValidationState.valid;
    } else if (!input) {
      setErrorMessage("");
      return ValidationState.invalid;
    } else {
      setErrorMessage(ERROR_TYPES.INVALID);
      return ValidationState.invalid;
    }
  };
  const onInputClick = (ev) => {
    pickerCalloutProps.calloutWidth = ev.currentTarget.clientWidth + ev.currentTarget.offsetLeft;
    if (!selectedKeys || selectedKeys.length === 0) {
      setSelectedKeys(getDropdownOptions(tenantId).map((o) => o.key));
    }
  };
  const onInputBlur = (ev) => {
    if (!errorMessage.startsWith(ERROR_TYPES.SEARCH_FAILED)) {
      if (!!ev.target.defaultValue) {
        setErrorMessage(ERROR_TYPES.INVALID);
      } else if (!currentSelected || currentSelected.length === 0) {
        setErrorMessage(props.required ? ERROR_TYPES.REQUIRED : "");
      } else {
        setErrorMessage("");
      }
    }
    setIsFocus(false);
  };
  const onDomainDropdownChange = (event, option, index) => {
    if (option) {
      const allKeys = getDropdownOptions(tenantId).map((o) => o.key);
      if (option.key === "") {
        setSelectedKeys(option.selected ? allKeys : []);
      } else if (allKeys.length >= 2 && selectedKeys.length === allKeys.length - 2) {
        setSelectedKeys(
          (prev) => option.selected ? allKeys : prev.filter((key) => key !== option.key).filter((key) => key !== "")
        );
      } else {
        setSelectedKeys(
          (prev) => option.selected ? [...prev, option.key] : prev.filter((key) => key !== option.key).filter((key) => key !== "")
        );
      }
      pickerCalloutProps.hidden = true;
    }
  };
  const onCheckBoxChange = (ev, checked) => {
    const selectedItems = currentSelected;
    const currentUser = EnvironmentService.getUser();
    if (checked) {
      let indexMe = selectedItems == null ? void 0 : selectedItems.findIndex((item) => item.text === currentUser.displayName);
      if (indexMe < 0) {
        let currentSubscriber = {
          id: currentUser.oid,
          text: currentUser.displayName,
          secondaryText: currentUser.email,
          type: "UserAccount",
          tenantId: currentUser.tid,
          subscriptionType: SUBSCRIPTION_TYPES.EntityBase
        };
        selectedItems.push(currentSubscriber);
        setCurrentSelected(selectedItems);
        setErrorMessage("");
        if (!!props.onChange) {
          props.onChange(selectedItems);
        }
      }
    } else {
      const displayName = currentUser.displayName;
      const indexMe = selectedItems == null ? void 0 : selectedItems.findIndex((item) => item.text === displayName);
      if (indexMe >= 0 && !!selectedItems) {
        const newItems = [...selectedItems.slice(0, indexMe), ...selectedItems.slice(indexMe + 1)];
        setCurrentSelected(newItems);
        setErrorMessage(props.required && newItems.length === 0 ? ERROR_TYPES.REQUIRED : "");
        if (!!props.onChange) {
          props.onChange(newItems);
        }
      }
    }
  };
  const isUserInSubscribers = () => {
    let include = false;
    const subscribers = currentSelected;
    const currentUser = EnvironmentService.getUser();
    include = subscribers.filter((i) => i.id === currentUser.oid).length > 0;
    return include;
  };
  const getDropdownOptions = (tenantId2) => {
    if (tenantId2 === TORUS_TENANT_ID) {
      const options = [{ key: MSFT_TENANT_ID, text: TenantNamesById[MSFT_TENANT_ID] }];
      return options;
    } else if (!!tenantId2 && tenantId2 !== MSFT_TENANT_ID) {
      const options = [
        { key: tenantId2, text: TenantNamesById[tenantId2] },
        { key: MSFT_TENANT_ID, text: TenantNamesById[MSFT_TENANT_ID] }
      ];
      const sortedOptions = options.sort((optionA, optionB) => optionA.text > optionB.text ? 1 : -1);
      return [{ key: "", text: TIPS.DROPDOWN_ALL_TEXT }, ...sortedOptions];
    } else {
      return [];
    }
  };
  const checkboxProps = {
    ariaLabel: ARIA_LABELS.SUBSCRIBE_ME_CHECKBOX,
    label: TIPS.CHECKBOX_LABEL,
    onChange: onCheckBoxChange,
    checked: isUserInSubscribers(),
    disabled: !!props.disableCheckBox
  };
  const loadingProps = {
    status: mergedAsyncRequestStatus,
    data: personas,
    failed: {
      heading: "There was an error",
      message: "TODO"
      //TODO
    },
    spinnerProps
  };
  const dropdownProps = {
    ariaLabel: ARIA_LABELS.DOMAIN_DROPDOWN,
    selectedKeys,
    multiSelect: true,
    options: getDropdownOptions(tenantId),
    styles: { title: { border: "0px", outline: "0px" }, dropdown: { width: "120px" } },
    onChange: onDomainDropdownChange
  };
  const peoplePickerStyles = isFocus ? {
    text: {
      border: "1px solid",
      outlineColor: !!errorMessage ? errorColor : focusColor
    }
  } : {
    text: {
      border: "1px solid",
      borderColor: !!errorMessage ? errorColor : defaultColor
    }
  };
  const inputProps = {
    placeholder: mergedAsyncRequestStatus === AsyncRequestStatus.Pending || mergedAsyncRequestStatus === AsyncRequestStatus.Failed || !!props.isReadOnly ? "" : TIPS.INPUT_PLACEHOLDER,
    onClick: onInputClick,
    onFocus: (ev) => {
      setIsFocus(true);
    }
  };
  const peoplePickerProps = {
    componentRef: pickerRef,
    key: "peoplePicker",
    selectionAriaLabel: ARIA_LABELS.PICKER_SELECTION,
    removeButtonAriaLabel: ARIA_LABELS.SUBSCRIBER_REMOVE,
    inputProps,
    pickerSuggestionsProps: suggestionProps,
    pickerCalloutProps,
    resolveDelay,
    selectedItems: currentSelected.map((item) => __spreadProps(__spreadValues({}, item), {
      disabled: !!item.subscriptionType && item.subscriptionType !== SUBSCRIPTION_TYPES.EntityBase
    })),
    onResolveSuggestions: onFilterChanged,
    onRenderSuggestionsItem: onRenderSuggestionItem,
    onChange: onItemsChange,
    onValidateInput: validateInput,
    onInputChange,
    onBlur: onInputBlur,
    styles: peoplePickerStyles
  };
  return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(
    SubscriberPicker,
    {
      ariaLabel: ARIA_LABELS.SUBSCRIBER_PICKER,
      required: props.required,
      isReadOnly: !!props.isReadOnly,
      peoplePickerProps,
      labelProps,
      iconProps,
      loadingProps,
      dropdownProps: tenantId === MSFT_TENANT_ID ? null : dropdownProps,
      checkboxProps: props.isReadOnly && !isSetSubscribersLoading ? checkboxProps : null,
      errorMessage
    }
  ) });
};
export {
  LoadPickSubscribersV2,
  useMergedSubscribers
};
//# sourceMappingURL=LoadPickSubscribersV2.js.map
